import React from "react"
import css from "../css"
import {scaled} from "../thumbs"
import {modalDepth} from "./modal"

import Adler32 from "adler32-js"

const h = new Adler32()
const hash = (str) => {
    h.reset()
    h.update(str)
    return h.digest('hex')
}

if (css) require('./lightbox.scss')

const images = []
const containers = []

export const Lightboxes = React.createClass({
    componentDidMount() {
        containers.push(this)
        document.body.setAttribute('modals', modalDepth())
    },
    componentWillUnmount() {
        containers.splice(containers.indexOf(this), 1)
    },
    close() {
        document.body.setAttribute('modals', modalDepth(-1))
    },
    render() {
        return <div className="lightbox" onClick={this.close}>
            {images.map((a,i) =>
                <a href="#" id={hash(a.filename)} className="lightbox-background" key={i}>
                    <span className="close" id="close"></span>
                    <img className="lightbox-img" src={scaled(a)} onClick={()=> console.log('check')}/>
                </a>
            )}
        </div>
    }
})

export const Lightbox = React.createClass({
    componentDidMount() {
        const id = '#'+hash(this.props.src.filename)
        images.push(this.props.src)
        for (const a of containers)
            a.forceUpdate()
        document.body.setAttribute('modals', modalDepth(id === location.hash ? 1 : 0))
    },
    componentWillUnmount() {
        images.splice(images.indexOf(this.props.src), 1)
        for (const a of containers)
            a.forceUpdate()
    },
    open() {
        document.body.setAttribute('modals', modalDepth(1))
    },
    render() {
        return  (
            <span style={{display: 'inline-block',...this.props.style}} className={this.props.className}>
                <a style={{display: 'inline-block'}} href={'#' + hash(this.props.src.filename)} onClick={this.open}>
                    {this.props.children}
                </a>
            </span>
        )
    }
})



// WEBPACK FOOTER //
// ./src/components/lightbox.jsx